import { useParams, Link } from 'react-router-dom';
import { articles, categories } from '@/mocks/articles';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageMeta from '@/components/base/PageMeta';
import Breadcrumb from '@/components/base/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = articles.filter((a) => a.category === slug);

  if (!category) {
    return (
      <>
        <Navbar />
        <main className="pt-16 min-h-screen flex items-center justify-center bg-background-50">
          <div className="text-center">
            <span className="w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-background-100 border border-background-200/70 text-foreground-400 text-2xl">
              <i className="ri-error-warning-line"></i>
            </span>
            <h2 className="font-heading text-xl font-bold text-foreground-900 mb-2">分类不存在</h2>
            <p className="text-foreground-600 text-sm mb-6">您访问的分类页面不存在或已被移除</p>
            <Link
              to="/"
              className="inline-flex px-4 py-2 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const categoryJsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: `${category.name} - 51暗网`,
      description: `${category.description}。51暗网每日更新${category.name}相关爆料内容。`,
      url: `http://chigualiao.cn/category/${slug}`,
      isPartOf: {
        '@type': 'WebSite',
        name: '51暗网',
        url: 'http://chigualiao.cn/',
      },
    },
  ];

  return (
    <>
      <PageMeta
        title={`${category.name} | 最新${category.name}爆料合集 - 51暗网`}
        description={`${category.description}。51暗网为您每日追踪最新${category.name}爆料，全网最快最全的${category.name}吃瓜内容。`}
        keywords={`${category.name},${category.name}爆料,${category.name}最新消息,51暗网,吃瓜黑料`}
        canonicalUrl={`http://chigualiao.cn/category/${slug}`}
        jsonLd={categoryJsonLd}
      />
      <Navbar />
      <main className="pt-16">
        <div className="w-full px-4 md:px-6 bg-background-100 border-b border-background-200/70">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: category.name },
            ]}
          />
        </div>

        <section className="py-12 md:py-20 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="mb-12">
              <div className="flex items-center gap-3 mb-3">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 text-xl">
                  <i className={category.icon}></i>
                </span>
                <div>
                  <h1 className="font-heading text-3xl md:text-4xl font-black text-foreground-900">
                    {category.name}
                  </h1>
                  <p className="text-foreground-600 text-sm mt-1">{category.description}</p>
                </div>
              </div>
              <p className="text-foreground-500 text-xs">
                共 {categoryArticles.length} 篇相关爆料
              </p>
            </div>

            {categoryArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {categoryArticles.map((article) => (
                  <ArticleCard
                    key={article.id}
                    slug={article.slug}
                    title={article.title}
                    excerpt={article.excerpt}
                    categoryName={category.name}
                    imageUrl={article.imageUrl}
                    imageUrlCompact={article.imageUrlCompact}
                    publishedAt={article.publishedAt}
                    views={article.views}
                    tags={article.tags}
                    featured={article.featured}
                    variant="compact"
                  />
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <span className="w-14 h-14 flex items-center justify-center mx-auto mb-4 rounded-full bg-background-100 border border-background-200/70 text-foreground-400 text-xl">
                  <i className="ri-inbox-line"></i>
                </span>
                <p className="text-foreground-600 text-sm mb-4">该分类下暂无爆料内容</p>
                <Link
                  to="/"
                  className="inline-flex px-4 py-2 rounded-lg border border-background-200/70 text-foreground-700 text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap"
                >
                  返回首页
                </Link>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}